import { Component } from 'react'
import PropTypes from 'prop-types'

const LanguageProvider = (WrappedComponent) =>
  class LanguageProviderHOC extends Component {
    static contextTypes = { language: PropTypes.string.isRequired }

    render() {
      return (
        <WrappedComponent {...this.props} language={this.context.language} />
      )
    }
  }

export default LanguageProvider
